"use strict";

class DeveloperApiSalesController {

    constructor($scope, $timeout, OTPService, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSDateService, SSAnalyticsService) {
        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;

        self.OTPService = OTPService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSDateService = SSDateService;
        self.SSAnalyticsService = SSAnalyticsService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        // Trigger View Event for API Sales Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_API_SALES,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.sale_selections = {};
        self.searchFilterErrors = {};
        self.selected_units_count = 0;

        self.offset = 0;
        self.limit = 10;
        self.selectedPage = 1;

        self.salesParams = {
            response_type: 1,
            include: 'units',
            offset: 0,
            limit: 99999,
            send_total_count: 1,
        };

        self.getProperties();
        self.initSaleStatuses();

        // Disable future date selection
        $('.date-input').datepicker({ maxDate: new Date(), dateFormat: "dd/mm/yy" });
    }

    getSales() {
        const self = this;

        self.searchFilterErrors = {};
        if(!self.isValidSearch()){
            return;
        }

        self.sales = [];
        let url = 'sec/developer/sales';
        let params = angular.copy(self.salesParams);

        if(self.salesParams.otp_date_from){
            params.otp_date_from = self.SSDateService.formateWithTimeAsNoon(self.salesParams.otp_date_from);
        }
        if(self.salesParams.otp_date_to){
            params.otp_date_to = self.SSDateService.formateWithTimeAsNoon(self.salesParams.otp_date_to);
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sales = response.data.sales;
            self.units = response.data.units;

            if(self.units && self.units.length){
                $.each(self.sales, function(index, sale){
                    let unit = self.units.find(x => x.id == sale.unit_id);
                    if(unit){
                        sale.unit_name = "#"+ unit.named_id;
                    } 
                });
            }

            self.loadSales(0);
        });
    }

    loadSales(offset){
        const self = this;

        self.offset = parseInt(offset);
        self.pagination_sales = self.sales.slice(self.offset, parseInt(self.limit) + offset);

        self.count = self.sales.length;
        self.pages = Math.ceil(self.count / self.limit);
        self.selectedPage = Math.floor(self.offset / self.limit) + 1;
        self.pagesArr = [];

        for (var i = 0; i < self.pages; i++) {
            self.pagesArr.push(i);
        }

        // SET 'CURRENT SELECTED RECORDS' COUNT
        if(parseInt(self.limit) < parseInt(self.pagination_sales.length)){
            self.selected_units_count = self.limit;
        }
        else{
            self.selected_units_count = self.pagination_sales.length;
        }
    }

    deleteSales(){
        const self = this;

        self.delete_confirmation_text = "";
        self.delete_confirmation_error = "";

        self.OTPService.getVerified(function (data) {
            $("#deleteSalesModal").modal('show');
        }, self.OTPService.TYPE_SESSION_2FA);
    }

    _deleteSales(){
        const self = this;

        if(self.delete_confirmation_text.length == 0 || 
           self.delete_confirmation_text.toLowerCase() !== 'permanently delete'){

            self.delete_confirmation_error = "Please type 'permanently delete' in the input field.";
            return;
        }

        $("#deleteSalesModal").modal('hide');

        var sale_ids = "";

        if(Object.keys(self.sale_selections).length){
            $.each(self.sale_selections, function(sale_id, selected){
                if(selected){
                    sale_ids += sale_id.toString()+",";
                }
            });
            sale_ids = sale_ids.slice(0, -1);
        }

        let url = 'sec/developer/sales/delete';
        let params = {
            sale_ids: sale_ids,
            property_id: self.salesParams.property_id,
            confirmation: self.delete_confirmation_text
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Sales deleted successfully.');

            try{
                var _sales = [];

                var _sale_ids = sale_ids.split(',');

                // Remove deleted sales from local sales array
                $.each(self.sales, function(index, sale){
                    if($.inArray(sale.id.toString(), _sale_ids) == -1){
                        _sales.push(sale);
                    }
                });

                self.no_of_sales_selected = 0;
                self.sales_selected = false;
                
                self.sales = _sales;
                self.loadSales(0);
            }
            catch(ex){
                console.log(ex);
            }
        });
    }

    isValidSearch(){
        const self = this;

        let isValid = true;

        if(!self.salesParams.property_id){
            self.searchFilterErrors.property_id = "Please select a project";
            isValid = false;
        } 

        return isValid;
    }

    getProperties() {
        const self = this;

        self.properties = [];
        let url = 'sec/developer/properties/list';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;
            self.updatePropertyFilter();
        });
    }

    toggleSelectAll(){
        const self = this;

        self.selectAll = event.target.checked;
        self.no_of_sales_selected = 0;

        if(self.selectAll){
            $.each(self.sales, function(index, sale){
                self.sale_selections[sale.id] = true;
                self.no_of_sales_selected++;
            }); 
            self.sales_selected = true;
        }
        else{
            $.each(self.sales, function(index, sale){
                self.sale_selections[sale.id] = false;
            }); 
            self.sales_selected = false;
        }
    }

    checkedAlert(){
        const self = this;

        self.no_of_sales_selected = 0;
        self.sales_selected = false;

        if(Object.keys(self.sale_selections).length){
            $.each(self.sale_selections, function(sale_id, selected){
                if(selected){
                    self.sales_selected = true;
                    self.no_of_sales_selected++;
                }
            });
        }

    }

    getStatusName(status_id){
        const self = this;

        let status_name = '--';

        if(!status_id){
            return status_name;
        }

        let status = self.sale_statuses.find(x => x.id == status_id);
        if(status){
            status_name = status.name;
        }

        return status_name;
    }

    initSaleStatuses(){
        const self = this;

        self.sale_statuses = [
            {'id': SHOWSUITE.SALE_STATUS_PENDING, 'name': 'Pending Buyer Signing'},
            {'id': SHOWSUITE.SALE_STATUS_APPROVED, 'name': 'Approved'},
            {'id': SHOWSUITE.SALE_STATUS_SPA_ENTERED, 'name': 'SPA Entered'},
            {'id': SHOWSUITE.SALE_STATUS_OTP, 'name': 'Pending SPA'},
            {'id': SHOWSUITE.SALE_STATUS_EXTENDED, 'name': 'Extended'},
            {'id': SHOWSUITE.SALE_STATUS_EXERCISED, 'name': 'Exercised'},
            {'id': SHOWSUITE.SALE_STATUS_EXPIRED, 'name': 'Expired'},
            {'id': SHOWSUITE.SALE_STATUS_INVALID, 'name': 'Invalid'},
            {'id': SHOWSUITE.SALE_STATUS_VERIFIED, 'name': 'Verified'},
            {'id': SHOWSUITE.SALE_STATUS_REJECTED, 'name': 'Rejected'},
            {'id': SHOWSUITE.SALE_STATUS_ABORTED, 'name': 'Aborted'},
            {'id': SHOWSUITE.SALE_STATUS_DONE, 'name': 'Completed'},
        ];

        self.updateStatusFilter();
    }

    updateStatusFilter(){
        const self = this;

        self.$timeout(function() { $("select.dashboard-select#status-select").niceSelect('update'); });
    }

    updatePropertyFilter(){
        const self = this;

        self.$timeout(function() { $("select.dashboard-select#property-select").niceSelect('update'); });
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.offset = parseInt(self.offset) - parseInt(self.limit);
        
        self.loadSales(self.offset);
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.offset = parseInt(self.offset) + parseInt(self.limit);

        self.loadSales(self.offset);
    }

    gotoPage(pageNum){
        const self = this;

        self.offset = parseInt(pageNum) * parseInt(self.limit);

        self.loadSales(self.offset);
    }
}

DeveloperApiSalesController.$inject = ['$scope', '$timeout', 'OTPService', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService', 'SSDateService', 'SSAnalyticsService'];
app.controller('DeveloperApiSalesController', DeveloperApiSalesController);


app.directive("datepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "datepicker()" METHOD USING THE "element" OBJECT.
        element.datepicker({
            dateFormat: "dd/mm/yy",
            changeMonth: true,
            changeYear: true,
            showTimePicker: false,
            showSecond:false,
            showMillisec:false,
            showMicrosec:false,
            showTimezone:false
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});